export const ENV = process.env.NODE_ENV;
export const API_ENV = process.env.API_ENV;

export const API_HOST = {
    // alpha  : '//192.168.1.207/icar_dev1/pc.php',
    // alpha  : '//test.carisok.com/icar_beta01/pc.php',
    alpha  : '//192.168.1.206/180/icar_101/pc.php',
    beta: '//test.carisok.com/icar_beta01/pc.php',
    albeta : 'https://beta-icar.carisok.com/pc.php',
    abtest : '//abtest-api.carisok.com/pc.php',
    release: '//ssapp-api.carisok.com/pc.php'
};



// WEBPACK FOOTER //
// ./src/constant.js